import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    imageCount: 0,
    rightAnswers: 0,
    wrongAnswers: 0,
    currentImage: '',
    imagesArray: [],
    resultsArray: {},
    isRight: false,
    quizId: 0,
    userId: -1,
    error: null
};

export const fetchImages = createAsyncThunk(
    'images/fetchImages',
    async ({quiz_id}, thunkAPI) => {
        if(quiz_id === 0){

            try {
                const quizPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/game', {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include'
                });
                const quiz = await quizPromise.json();
                return quiz;
            } catch (err) {
                return thunkAPI.rejectWithValue(err.message);
            }

        } else {

            try {
                const quizPromise = await fetch(process.env.REACT_APP_DATABASE_URL + `/quizzes/${quiz_id}`, {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include'
                });
                const quiz = await quizPromise.json();
                return quiz;
            } catch (err) {
                return thunkAPI.rejectWithValue(err.message);
            }
        }
    }
);

export const imagesSlice = createSlice({
    name: 'images',
    initialState,
    reducers: {
        buttonClicked: (state, action) => {

            if (state.imagesArray[state.imageCount].displayed === false) {

                state.imagesArray[state.imageCount].displayed = true;

                if (action.payload === state.imagesArray[state.imageCount].result) {
                    state.isRight = true;
                    state.rightAnswers += 1;
                    state.resultsArray[state.imagesArray[state.imageCount].id] = true;
                } else {
                    state.isRight = false;
                    state.wrongAnswers += 1;
                    state.resultsArray[state.imagesArray[state.imageCount].id] = false;
                }

                state.currentImage = state.imagesArray[state.imageCount].clearImage;

            } else {
                state.imageCount += 1;
                if (state.imageCount < state.imagesArray.length) {
                    state.currentImage = state.imagesArray[state.imageCount].hiddenImage;
                }
            }
        },
        resetState: (state, action) => {
            state.imageCount = 0;
            state.rightAnswers = 0;
            state.wrongAnswers = 0;
            state.currentImage = '';
            state.imagesArray = [];
            state.isRight = false;
            state.quizId = 0;
            state.resultsArray = {};
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchImages.pending, (state, action) => {
            state.error = null;
        })
        .addCase(fetchImages.fulfilled, (state, action) => {
            const quizData = action.payload;
            if (!quizData) return;
            const imagesData = quizData.images_array;
            const quizId = quizData.quiz_id;
            const userId = quizData.user_id;

            if (imagesData.length !== 0) {

                state.currentImage = imagesData[0].hiddenImage;

                for (let i=0; i < imagesData.length; i++){
                    imagesData[i].displayed = false;
                }
            }

            state.imagesArray = imagesData;
            state.quizId = quizId;
            state.userId = userId;
            state.error = null;
        })
        .addCase(fetchImages.rejected, (state, action) => {
            state.error = action.payload || 'Failed to load game data. Please try again.';
        })
    }
});

export const { buttonClicked, resetState, updatePlayerStatus } = imagesSlice.actions;
export default imagesSlice.reducer;
